import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

export const Hero = () => {
  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background glow */}
      <div className="hero-glow" />
      
      {/* Grid pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:64px_64px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,black_40%,transparent_100%)]" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm mb-8"
            data-testid="hero-badge"
          >
            <span className="w-2 h-2 rounded-full bg-primary" />
            <span className="text-sm text-muted-foreground">Für Bildungsträger im AZAV-Kontext</span>
          </motion.div>

          {/* Headline */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-bold tracking-tight leading-none mb-6"
            data-testid="hero-headline"
          >
            Einfach zur{' '}
            <span className="text-primary">AZAV-Zulassung</span>{' '}
            für Bildungsträger.
          </motion.h1>

          {/* Subheadline */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed"
            data-testid="hero-subheadline"
          >
            Beratung, Auditbegleitung und QM-Strukturen – von der Gründung bis zum erfolgreichen Überprüfungsaudit.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4"
            data-testid="hero-cta"
          >
            <Link to="/kontakt">
              <Button 
                data-testid="hero-cta-primary"
                className="bg-primary hover:bg-[#05b873] text-black font-semibold rounded-lg px-8 py-6 text-lg transition-all duration-300"
              >
                Kostenlose Ersteinschätzung
              </Button>
            </Link>
            <Link to="/leistungen">
              <Button 
                data-testid="hero-cta-secondary"
                variant="outline"
                className="bg-transparent border border-white/30 hover:bg-white/5 hover:border-white/50 text-white hover:text-white rounded-lg px-8 py-6 text-lg transition-all"
              >
                Leistungen ansehen
              </Button>
            </Link>
          </motion.div>
        </div>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-20 md:mt-32"
          data-testid="hero-stats"
        >
          {[
            { value: '50+', label: 'Begleitete Zulassungen' },
            { value: '0', label: 'Abweichungen im Audit' },
            { value: '5+', label: 'Jahre Erfahrung' },
            { value: '24h', label: 'Reaktionszeit' },
          ].map((stat, index) => (
            <div 
              key={index} 
              className="text-center p-6 rounded-2xl border border-white/5 bg-white/[0.02] backdrop-blur-sm"
            >
              <div className="text-3xl md:text-4xl font-heading font-bold text-white mb-2">{stat.value}</div>
              <div className="text-sm text-muted-foreground">{stat.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
